import { useCustomSnackbar } from "../../components/Misc/useSnackbar";
import DefaultLayout from "../../layout/Layout";
import { updateUser } from "../../redux/actions";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";

const Login2 = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const toast = useCustomSnackbar();

  const baseUrl = "https://eagleanalytix.com/api";

  useEffect(() => {
    const authenticate = async () => {
      const token = searchParams.get("token");
      const email = searchParams.get("email");

      if (!token || !email) {
        setLoading(false);
        setError("Missing token or email parameter");
        toast({
          type: "error",
          message: "Missing token or email parameter",
        });
        return;
      }

      try {
        const url = `${baseUrl}/automatiq-cross-login`;
        const option = {
          method: "POST",
          url,
          headers: { "Content-Type": "application/json" },
          data: JSON.stringify({ token, email }),
        };

        const { data } = await axios(option);
        setLoading(false);

        if (data.status === true && data.token) {
          localStorage.setItem("userData", JSON.stringify(data));
          dispatch(updateUser(data));
          navigate("/account/list");
        } else {
          setError(data.message || "Authentication failed");
          toast({
            type: "error",
            message: data.message || "Authentication failed",
          });
        }
      } catch (error) {
        setLoading(false);
        const { response } = error;
        const errorMessage =
          response?.data?.message || "Something went wrong. Try again later";
        setError(errorMessage);
        toast({
          type: "error",
          message: errorMessage,
        });
      }
    };

    authenticate();
  }, [searchParams, navigate, dispatch, toast]);

  return (
    <DefaultLayout isLogin={true}>
      <div className="rounded-sm shadow-default border-strokedark bg-boxdark h-full">
        <div className="flex flex-wrap items-center h-full">
          <div className="w-full border-strokedark xl:w-1/2 m-auto">
            <div className="w-full p-4 sm:p-12.5 xl:p-17.5 h-full flex items-center justify-center">
              {loading ? (
                <div className="text-center">
                  <h2 className="mb-4 text-2xl font-bold text-white sm:text-title-xl2">
                    Authenticating now..
                  </h2>
                  <div className="flex justify-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
                  </div>
                </div>
              ) : error ? (
                <div className="text-center">
                  <h2 className="mb-4 text-2xl font-bold text-red-500 sm:text-title-xl2">
                    Authentication Failed
                  </h2>
                  <p className="text-white mb-4">{error}</p>
                  <button
                    onClick={() => navigate("/login")}
                    className="px-6 py-2 bg-primary text-white rounded-lg hover:bg-opacity-90 transition"
                  >
                    Go to Login
                  </button>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </DefaultLayout>
  );
};

export default Login2;
